<template>
  <div class="">
    <top-header
      :type="3"
      :isShow="false"
      :bgColor="bgColor"
      :textColor="textColor"
    />
    <div class="top_banner" ref="topBanner">
      <swiper class="swiper" :options="swiperOptionh" ref="mySwiper">
        <swiper-slide v-if="videoList.length">
          <swiper class="swiper vertical" :options="swiperOptionv">
            <swiper-slide
              class="slide_video_con"
              v-for="(item, index) in videoList"
              :key="index"
            >
              <div class="cover m_flex_box flex_hc flex_vc" @click="showModel">
                <van-icon name="play-circle-o" />
              </div>
              <img :src="imgPath + 'sVideo/' + item.imgId + '.jpg'" alt="" />
            </swiper-slide>
          </swiper>
        </swiper-slide>
        <swiper-slide>
          <swiper class="swiper vertical" :options="swiperOptionv">
            <swiper-slide
              class="slide_video_con"
              v-for="(item, index) in swiperImg"
              :key="index"
            >
              <img
                @click="showModel"
                :src="imgPath + 'sImgMax/' + item.imgid + '.jpg'"
                alt=""
              />
            </swiper-slide>
            <swiper-slide v-if="!videoList.length && !swiperImg.length">
              <img v-lazy="" alt="" />
            </swiper-slide>
          </swiper>
        </swiper-slide>
      </swiper>
      <div class="total">共{{ swiperImg.length + videoList.length }}张</div>
      <div class="pagination m_flex_box flex_vc flex_hc">
        <span
          v-if="videoList.length"
          :class="topSwiperIndex === 0 ? 'active' : ''"
          @click="toSlide(0)"
          >视频</span
        >
        <span :class="topSwiperIndex === 1 ? 'active' : ''" @click="toSlide(1)"
          >图片</span
        >
      </div>
    </div>
    <div class="top_info">
      <div class="m_flex_box flez_vc flex_jz top">
        <h3 class="line_comp1">{{ obj.tgmc ? obj.tgmc : "-" }}</h3>
        <p class="price">
          均价<span>{{ obj.priceStr }}</span
          ><span v-if="obj.priceStr !== '暂无'">元/m²</span>
        </p>
      </div>
      <div class="m_flex_box flex_vc flex_jz">
        <div class="score m_flex_box flex_vc">
          <img
            src="@/assets/img/star.png"
            alt=""
            v-for="item in obj.zScore"
            :key="item"
          />
          <img
            src="@/assets/img/star_.png"
            v-for="item in 5 - zScore"
            :key="item + '_'"
            alt=""
          />
          <span>{{ obj.zScore ? obj.zScore : 0 }}分</span>
        </div>
        <p class="fwl">
          浏览量<span>{{ obj.fwl || 0 }}</span>
        </p>
      </div>
      <div class="icon m_flex_box flex_vc">
        <span>{{ obj.xsqkStr ? obj.xsqkStr : "-" }}</span>
        <div v-for="(item, index) in obj.xmts" :key="index">
          <p v-if="index < 4">
            <i>{{ item }}</i>
          </p>
        </div>
      </div>
      <div class="m_flex_box flex_vc flex_jz middle_blue">
        <p class="left m_flex_box flex_vc">
          <img src="@/assets/img/_con.png" alt="" />
          <span
            >最低总价：<i>{{ obj.minPrice || "-" }}</i
            >万</span
          >
        </p>
        <p class="right m_flex_box flex_vc" @click="toOneHouse">
          <img src="@/assets/img/con_.png" alt="" />
          <span>查看一房一价</span>
        </p>
      </div>
    </div>
    <div class="text_con">
      <p class="row m_flex_box flex_vc">
        备案名称<span class="line_comp1">{{ obj.xmmc || "-" }}</span>
      </p>
      <div class="m_flex_box flex_vc flex_jz">
        <p class="row m_flex_box flex_vc flex-1">
          最新预售<span class="line_comp1">{{
            obj.kpsj | timeFormat("yyyy-MM-dd")
          }}</span>
        </p>
        <p class="row m_flex_box flex_vc flex-1">
          上房时间<span class="line_comp1">{{
            obj.sfsj | timeFormat("yyyy-MM-dd")
          }}</span>
        </p>
      </div>
      <p class="row m_flex_box flex_vc">
        开发企业<span class="line_comp1">{{ obj.corpName || "-" }}</span>
      </p>
      <p class="row m_flex_box flex_vc">
        售楼处地址<span class="line_comp1">{{ obj.xsdz || "-" }}</span>
      </p>
      <p class="row m_flex_box flex_vc">
        项目地址<span class="line_comp1">{{ obj.xmdz || "-" }}</span>
      </p>
      <router-link :to="'/projectXq?itemId=' + itemId" class="detail_btn"
        >更多详细信息</router-link
      >
    </div>
    <div class="bor_b">
      <div class="middle_btn m_flex_box flex_vc flex_jz">
        <div
          class="m_flex_box flex_vc flex_hc"
          @click="showMsg('预售早知道', '预售')"
        >
          <img src="@/assets/img/ys.png" alt="" />
          <span>预售早知道</span>
        </div>
        <div
          class="m_flex_box flex_vc flex_hc"
          @click="showMsg('楼盘动态', '楼盘')"
        >
          <img src="@/assets/img/dt.png" alt="" />
          <span>楼盘动态</span>
        </div>
        <div
          class="m_flex_box flex_vc flex_hc"
          @click="showMsg('我要买房', '房屋')"
        >
          <img src="@/assets/img/mf.png" alt="" />
          <span>我要买房</span>
        </div>
      </div>
    </div>
    <div class="mid_pad" v-show="showPad"></div>
    <div class="detail_nav_bar" :class="showPad ? 'fixed' : ''">
      <span :class="tabIndex === 0 ? 'active' : ''">楼盘首页</span>
      <span @click="toUrl('/projectXq')">楼盘详情</span>
      <span @click="toUrl('/saleInfo')">销售状态</span>
      <span @click="toUrl('/oneHouseOnePrice')">一房一价</span>
      <span @click="toUrl('/sameHouseList')">二手房源</span>
      <span @click="toUrl('/newsList')">楼盘动态</span>
      <span @click="toUrl('/newsList', 1)">楼盘快讯</span>
      <span @click="toUrl('/photo')">楼盘相册</span>
      <span @click="toUrl('/argumentList')">楼盘点评</span>
      <span @click="toUrl('/fundSupervision')">资金监管</span>
    </div>
    <div class="pad_top_inner"></div>
    <div class="bor_b" v-if="obj.ms">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">楼盘简介</h3>
          <router-link
            :to="'/projectXq?type=1&itemId=' + itemId"
            class="arrow m_flex_box flex_vc"
          >
            <span>查看全部</span>
            <van-icon name="arrow" />
          </router-link>
        </div>
        <div class="text_con line_comp3">{{ obj.ms || "-" }}</div>
      </div>
    </div>
    <div class="bor_b" v-if="JSON.stringify(adviserList) != '{}'">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">严选顾问</h3>
        </div>
        <div class="people_con">
          <div class="inner inner_new">
            <div class="info_a">
              <div>
                <img :src="adviserList.avatar" alt="" class="atavr" />
              </div>
              <div>
                <div class="name">
                  {{
                    adviserList.realName
                      ? adviserList.realName
                      : adviserList.realName
                  }}
                </div>
                <!-- <div class="phone">{{ adviserList.phone ? adviserList.phone : adviserList.phone }}</div> -->
              </div>
            </div>
            <div class="info_c">
              <div class="btn_con m_flex_box flex_vc flex_jz">
                <div @click="talkUrl(adviserList.chatUrl)">
                  <img src="@/assets/img/zx.png" alt="" />
                  <p>在线咨询</p>
                </div>
                <a @click.stop="callTo(adviserList.phone, 2, adviserList.id)">
                  <img src="@/assets/img/phone.png" alt="" />
                  <p>电话联系</p>
                </a>
                <div @click="toBuy">
                  <img src="@/assets/img/tabbar/11.png" alt="" />
                  <p>我要买房</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bor_b" v-if="personList.length">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">置业顾问</h3>
        </div>
        <div class="people_con">
          <div class="inner" v-for="(item, index) in personList" :key="index">
            <div>
              <img
                v-if="item.lxStr === '置业顾问'"
                :src="item.tx ? imgPath + 'sTx/' + item.tx + '.jpg' : pic"
                alt=""
                class="atavr"
              />
              <img
                v-else
                :src="
                  item.brokerImg
                    ? imgPath + 'sClf/' + item.brokerImg + '.jpg'
                    : pic
                "
                alt=""
                class="atavr"
              />
            </div>
            <div>
              <p class="name">
                {{ item.brokerName ? item.brokerName : item.realName }}
              </p>
              <div class="btn_con m_flex_box flex_vc flex_jz">
                <div @click="toTalk(item.id)">
                  <img src="@/assets/img/zx.png" alt="" />
                  <p>在线咨询</p>
                </div>
                <a
                  @click.stop="
                    callTo(
                      item.phone,
                      item.lxStr === '房产经纪人' ? 1 : 2,
                      item.id
                    )
                  "
                  style="margin-left:0.1rem"
                >
                  <img src="@/assets/img/phone.png" alt="" />
                  <p>电话联系</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bor_b">
      <div class="main_inner">
        <div
          class="m_flex_box flex_vc flex_jz tit_con"
          style="margin-bottom: 0;"
        >
          <h3 class="inner_tit">售楼处电话</h3>
          <!-- <div>{{ obj.zxdh }}</div> -->
          <div
            style="padding:0.1rem 0.2rem;background:#3072F5;color:#fff;border-radius: 5px;"
            @click="callTo(obj.zxdh, 3, obj.itemId)"
          >
            拨打电话
          </div>
        </div>
      </div>
    </div>
    <div class="bor_b" v-if="hxList.length">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">楼盘户型</h3>
          <div @click="toImg" class="arrow m_flex_box flex_vc">
            <span>查看全部</span>
            <van-icon name="arrow" />
          </div>
        </div>
        <div class="hx_con">
          <div
            class="inner"
            v-for="(item, index) in hxList"
            :key="index"
            @click="toImg"
          >
            <div class="img_con">
              <img v-lazy="imgPath + 'sImgMax/' + item.imgid + '.jpg'" alt="" />
            </div>
            <p class="line_comp1">{{ item.ms || item.name }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="bor_b" v-if="oneHouseList.length">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">一房一价</h3>
          <router-link
            :to="'/oneHouseOnePrice?itemId=' + itemId"
            class="arrow m_flex_box flex_vc"
          >
            <span>查看全部</span>
            <van-icon name="arrow" />
          </router-link>
        </div>
        <div class="price_list">
          <div
            class="inner m_flex_box flex_vc flex_jz"
            v-for="(item, index) in oneHouseList"
            :key="index"
            @click="toDetail(item.itemId, item.houseId)"
          >
            <div class="left">
              <img
                v-lazy="imgPath + 'sImgHouse/' + item.houseMapID + '.jpg'"
                alt=""
              />
              <p>{{ item.hx }}</p>
            </div>
            <div class="right">
              <div class="m_flex_box flex_vc flex_jz top">
                <h5 class="line_comp1">{{ item.tgmc }}</h5>
                <span>{{ item.houseState }}</span>
              </div>
              <img
                :src="'data:image/jpg;base64,' + item.base64String"
                class="info"
                alt=""
              />
              <div class="m_flex_box flex_vc icon_con">
                <span v-if="item.houseState">{{
                  item.houseState ? item.houseState : "-"
                }}</span>
                <span v-if="item.isDecorate">{{
                  item.isDecorate ? item.isDecorate : "-"
                }}</span>
                <span v-if="item.saleHouseUse">{{
                  item.saleHouseUse ? item.saleHouseUse : "-"
                }}</span>
                <span v-if="item.structType !== 'null'">{{
                  item.structType ? item.structType : "-"
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bor_b" v-if="newsList.length">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">楼盘新闻</h3>
          <router-link
            :to="'/newsList?type=1&itemId=' + itemId"
            class="arrow m_flex_box flex_vc"
          >
            <span>查看全部</span>
            <van-icon name="arrow" />
          </router-link>
        </div>
        <div class="news_list">
          <div
            class="inner m_flex_box flex_vc flex_jz"
            v-for="(item, index) in newsList"
            :key="index"
            @click="toNews(item.nrid)"
          >
            <div class="right">
              <p class="tit line_comp2">{{ item.mc }}</p>
              <p class="time m_flex_box flex_vc">
                <i>新闻</i>
                <span>{{ item.creatDate }}</span>
              </p>
            </div>
            <div class="left">
              <img v-lazy="imgPath + 'sImgXw/' + item.imgid + '.jpg'" alt="" />
            </div>
          </div>
        </div>
        <div class="ad_con" v-for="item in ad" :key="item.imgid">
          <img
            :src="imgPath + 'sImgGg/' + item.imgid + '.' + item.suffix"
            alt=""
            v-if="'null' !== item.itemId && item.itemId"
            @click="toProject(item.itemId, item.old)"
          />
          <a v-else :href="item.lj">
            <img
              :src="imgPath + 'sImgGg/' + item.imgid + '.' + item.suffix"
              alt=""
            />
          </a>
        </div>
      </div>
    </div>
    <div class="bor_b" v-if="nktList.length">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">项目鸟瞰图</h3>
        </div>
        <div class="nkt_tab">
          <span
            :class="nktCurrent === index ? 'active' : ''"
            v-for="(item, index) in nktList"
            :key="index"
            @click="setNkt(index)"
            >{{ item.ms }}</span
          >
        </div>
        <router-link :to="'/nkt?type=' + nktCurrent + '&itemId=' + itemId">
          <div class="nkt_main">
            <div class="nkt_con">
              <div id="box">
                <img
                  :src="
                    imgPath + 'sImgMax/' + nktList[nktCurrent].imgid + '.jpg'
                  "
                  alt=""
                />
              </div>
            </div>
          </div>
        </router-link>
      </div>
    </div>
    <div class="bor_b" v-if="announceArr.length || announceArr1.length">
      <div class="main_inner announce_main">
        <div class="map_tab m_flex_box flex_vc flex_hc">
          <span
            :class="announceTab === 0 ? 'active' : ''"
            @click="announceTab = 0"
            v-if="announceArr.length"
            >项目预售</span
          >
          <span
            :class="announceTab === 1 ? 'active' : ''"
            @click="announceTab = 1"
            v-if="announceArr1.length"
            >项目现售</span
          >
        </div>
        <div v-show="announceTab === 0 && announceArr.length">
          <div
            class="announce_blue m_flex_box flex_vc flex_hc"
            @click="showAnnounce = true"
          >
            <span>{{ checkObj.certificateNo || "-" }}</span>
            <van-icon name="play" class="play" />
          </div>
          <van-popup v-model="showAnnounce" position="bottom">
            <van-picker
              show-toolbar
              :columns="announceArr"
              value-key="certificateNo"
              @confirm="confirm"
              @cancel="showAnnounce = false"
            />
          </van-popup>
          <div class="announce_img">
            <img
              v-lazy="imgPath + 'sImgSale/' + checkObj.salePermitId + '.jpg'"
              alt=""
            />
          </div>
          <div class="announce_list">
            <div class="row m_flex_box flex_vc">
              <span>入网套数</span
              >{{
                checkObj.rwzts !== "" || checkObj.rwzts !== null
                  ? checkObj.rwzts
                  : "-"
              }}
            </div>
            <div class="row m_flex_box flex_vc">
              <span>成交套数</span
              >{{
                checkObj.cjts !== "" || checkObj.cjts !== null
                  ? checkObj.cjts
                  : "-"
              }}
            </div>
            <div class="row m_flex_box flex_vc">
              <span>不可售套数</span
              >{{
                checkObj.bksts !== "" || checkObj.bksts !== null
                  ? checkObj.bksts
                  : "-"
              }}
            </div>
            <div class="row m_flex_box flex_vc">
              <span>剩余套数</span
              >{{
                checkObj.kxsts !== "" || checkObj.kxsts !== null
                  ? checkObj.kxsts
                  : "-"
              }}
            </div>
            <div class="row m_flex_box flex_vc">
              <span>行政区</span
              >{{
                checkObj.district !== "" || checkObj.district !== null
                  ? checkObj.district
                  : "-"
              }}
            </div>
          </div>
          <div class="btn_con m_flex_box flex_vc flex_jz">
            <span @click="toDetail1(checkObj.saleItemId)">销售进度</span>
            <span @click="toUrl('/saleInfo')">销售状态</span>
            <span @click="toDetail3(checkObj.saleItemId)">预售查看</span>
          </div>
        </div>
        <div v-show="announceTab === 1 && announceArr1.length">
          <div
            class="announce_blue m_flex_box flex_vc flex_hc"
            @click="showAnnounce1 = true"
          >
            <span>{{ checkObj1.certificateNo || "-" }}</span>
            <van-icon name="play" class="play" />
          </div>
          <van-popup v-model="showAnnounce1" position="bottom">
            <van-picker
              show-toolbar
              :columns="announceArr1"
              value-key="certificateNo"
              @confirm="confirm1"
              @cancel="showAnnounce1 = false"
            />
          </van-popup>
          <div class="announce_list">
            <div class="row m_flex_box flex_vc">
              <span>发放日期</span
              >{{
                checkObj1.certificateTime !== "" ||
                checkObj1.certificateTime !== null
                  ? checkObj1.certificateTime
                  : "-"
              }}
            </div>
            <div class="row m_flex_box flex_vc">
              <span>包含楼盘</span
              >{{
                checkObj1.saleScope !== "" || checkObj1.saleScope !== null
                  ? checkObj1.saleScope
                  : "-"
              }}
            </div>
            <div class="row m_flex_box flex_vc">
              <span>入网套数</span
              >{{
                checkObj1.rwzts !== "" || checkObj1.rwzts !== null
                  ? checkObj1.rwzts
                  : "-"
              }}
            </div>
            <div class="row m_flex_box flex_vc">
              <span>成交套数</span
              >{{
                checkObj1.cjts !== "" || checkObj1.cjts !== null
                  ? checkObj1.cjts
                  : "-"
              }}
            </div>
            <div class="row m_flex_box flex_vc">
              <span>不可售套数</span
              >{{
                checkObj1.bksts !== "" || checkObj1.bksts !== null
                  ? checkObj1.bksts
                  : "-"
              }}
            </div>
            <div class="row m_flex_box flex_vc">
              <span>剩余套数</span
              >{{
                checkObj1.kxsts !== "" || checkObj1.kxsts !== null
                  ? checkObj1.kxsts
                  : "-"
              }}
            </div>
            <div class="row m_flex_box flex_vc">
              <span>行政区</span
              >{{
                checkObj1.district !== "" || checkObj1.district !== null
                  ? checkObj1.district
                  : "-"
              }}
            </div>
          </div>
          <div class="btn_con m_flex_box flex_vc flex_jz">
            <span @click="toDetail1(checkObj1.saleItemId)">销售进度</span>
            <span @click="toUrl('/saleInfo')">销售状态</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bor_b">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">位置及周边配套</h3>
        </div>
        <div>
          该功能正在升级中
        </div>
        <div class="map_tab_con" v-if="false">
          <span
            :class="keyword === '公交' ? 'active' : ''"
            @click="changeMap('公交')"
            >公交</span
          >
          <span
            :class="keyword === '医疗' ? 'active' : ''"
            @click="changeMap('医疗')"
            >医疗</span
          >
          <span
            :class="keyword === '银行' ? 'active' : ''"
            @click="changeMap('银行')"
            >银行</span
          >
          <span
            :class="keyword === '商业' ? 'active' : ''"
            @click="changeMap('商业')"
            >商业</span
          >
          <span
            :class="keyword === '学校' ? 'active' : ''"
            @click="changeMap('学校')"
            >学校</span
          >
        </div>
        <div class="map_con" v-if="false">
          <baidu-map
            class="bm-view"
            :center="center1"
            :scroll-wheel-zoom="true"
            :zoom="zoom"
            @ready="handler"
          >
            <bm-local-search
              :keyword="keyword"
              location="徐州"
              :nearby="nearby"
              :panel="false"
              @searchcomplete="search"
              :auto-viewport="true"
            ></bm-local-search>
            <bm-marker
              :position="center"
              :scroll-wheel-zoom="true"
              :icon="{ url: icon, size: { width: 34, height: 40 } }"
              :top="true"
              :zIndex="11"
            ></bm-marker>
            <bm-marker
              v-for="(item, index) in mapList"
              :key="index"
              :position="item.point"
              :scroll-wheel-zoom="true"
              :icon="{ url: icon1, size: { width: 24, height: 36 } }"
              :offset="offset"
            ></bm-marker>
            <bm-info-window
              :position="infoPosition"
              :show="show"
              @open="infoWindowOpen"
              @close="infoWindowClose"
            >
              <div v-html="infoWindow"></div>
            </bm-info-window>
          </baidu-map>
          <div class="map_list">
            <div
              class="row m_flex_box flex_vc flex_jz"
              v-for="(item, index) in mapList"
              :key="index"
              @click="setCenter(item)"
            >
              <span>{{ index + 1 }}</span>
              <div class="right">
                <h5>{{ item.title }}</h5>
                <p>{{ item.address }}</p>
              </div>
            </div>
          </div>
          <transition name="slide-y" mode="out-in">
            <div
              class="no_map m_flex_box flex_vc flex_hc"
              v-if="(mapList && !mapList.length) || !mapList"
            >
              暂无{{ keyword }}数据
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="bor_b">
      <div class="main_inner argument_con">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">真实评价</h3>
        </div>
        <div class="argument_top">
          <div class=" m_flex_box flex_vc">
            <h5>
              <span>{{ zScore }}</span
              >分
            </h5>
            <div class="m_flex_box flex_vc icon_con">
              <img
                src="@/assets/img/star.png"
                alt=""
                v-for="item in obj.zScore"
                :key="item"
              />
              <img
                src="@/assets/img/star_.png"
                v-for="item in 5 - zScore"
                :key="item + '_'"
                alt=""
              />
            </div>
          </div>
          <div class="m_flex_box flex_vc score_text">
            <span>综合{{ scoreObj.zScore }}分</span>
            <span>信誉{{ scoreObj.score1 }}分</span>
            <span>品质{{ scoreObj.score2 }}分</span>
            <span>质量{{ scoreObj.score3 }}分</span>
            <span>服务{{ scoreObj.score4 }}分</span>
          </div>
          <router-link
            :to="'/argumentSubmit?itemId=' + itemId"
            class="argument_btn"
            >我要点评</router-link
          >
        </div>
        <div class="argument_list">
          <div class="row" v-for="(item, index) in argumentList" :key="index">
            <div class="row_top m_flex_box flex_vb flex_jz">
              <div class="m_flex_box flex_vc">
                <img class="avatr" src="@/assets/img/tx.jpg" alt="" />
                <div class="top_l_r">
                  <p>
                    {{ item.lx === 0 ? "业主" : "游客" }}
                    {{ item.lx === 0 ? item.buyerName + "**" : "" }}
                  </p>
                  <div class="m_flex_box flex_vc icon_con">
                    <img
                      v-for="(inner, ind) in item.zScore"
                      :key="ind"
                      src="@/assets/img/star.png"
                      alt=""
                    />
                    <img
                      v-for="(inner, ind) in 5 - item.zScore"
                      :key="ind + '*'"
                      src="@/assets/img/star_.png"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <span class="time">{{ item.createDate }}</span>
            </div>
            <div class="argumennt_b">
              <h5>{{ item.comment }}</h5>
              <div class="img_list">
                <img
                  :src="'data:image/jpg;base64,' + inner"
                  alt=""
                  v-for="(inner, ind) in item.img"
                  :key="ind + '*'"
                  @click="showImg(item.img, ind)"
                />
              </div>
              <p class="m_flex_box flex_vc score_text">
                <span>综合{{ item.zScore }}分</span>
                <span>信誉{{ item.score1 }}分</span>
                <span>品质{{ item.score2 }}分</span>
                <span>质量{{ item.score3 }}分</span>
                <span>服务{{ item.score4 }}分</span>
              </p>
            </div>
          </div>
          <router-link
            :to="'/argumentList?itemId=' + itemId"
            class="go_btn"
            v-if="argumentList.length"
            >查看全部评价
          </router-link>
        </div>
      </div>
    </div>
    <div class="bor_b">
      <div class="main_inner">
        <div class="m_flex_box flex_vc flex_jz tit_con">
          <h3 class="inner_tit">推荐楼盘</h3>
        </div>
        <div class="list_con new_list">
          <div
            class="inner m_flex_box flex_vc"
            v-for="(item, index) in recommendList"
            :key="index"
            @click="getDetail(item.id, item.old)"
          >
            <img
              class="banner"
              v-lazy="imgPath + 'sImgMin/' + item.xmfm + '.jpg'"
            />
            <div class="new_r">
              <div class="m_flex_box flex_vc flex_jz tit">
                <h4 class="line_comp1">{{ item.tgmc }}</h4>
                <i>{{ item.xsqkStr }}</i>
              </div>
              <p class="line_comp1 col_gray">
                {{ item.xmdz ? item.xmdz : "暂无地址信息" }}
              </p>
              <div class="m_flex_box flex_jz flex_vc">
                <div class="m_flex_box flex_vc info">
                  <p>
                    评分：<span>{{ item.zScore }}</span>
                  </p>
                  <p>访问量：{{ item.fwl | formatwan }}</p>
                </div>
                <a @click.stop="callTo(item.zxdh, 3, item.id)" class="tel"
                  ><img src="@/assets/img/tel.png" alt=""
                /></a>
              </div>
              <div class="m_flex_box flex_jz flex_vc">
                <div class="col_red m_flex_box flex_vb">
                  <h4>{{ item.priceStr }}</h4>
                  <span v-show="item.priceStr !== '暂无'">元/平</span>
                </div>
                <p v-if="item.ksts" class="m_flex_box flex_vc text">
                  <span @click.stop @click="toOneHouseOnePrice(item.id)"
                    >一房一价</span
                  >
                  <van-icon name="play" />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main_inner" v-if="oldList.length">
      <div class="m_flex_box flex_vc flex_jz tit_con">
        <h3 class="inner_tit">在售二手房</h3>
      </div>
      <div class="list_con old_list">
        <div
          class="inner m_flex_box flex_vc"
          v-for="(item, index) in oldList"
          :key="index"
          @click="toOld(item)"
        >
          <div class="inner_l">
            <img
              class="banner"
              v-lazy="imgPath + 'sClf/' + item.fileId + '.jpg'"
            />
          </div>
          <div class="new_r">
            <div class="m_flex_box flex_vc flex_jz tit">
              <h4 class="line_comp1">{{ item.tgmc }}</h4>
              <i>在售</i>
            </div>
            <p class="line_comp1 col_gray">
              {{ item.xzqh }} / {{ item.zmjCount }}m² / {{ item.room }}室{{
                item.hall
              }}厅
            </p>
            <div class="m_flex_box flex_jz">
              <div class="price m_flex_box flex_vb">
                <h4>{{ item.listedPrice / 10000 }}万</h4>
                <p>{{ item.unitPrice }}元/平</p>
              </div>
              <a
                @click.stop="
                  callTo_(item.phoneNum, item.listedType, item.listedUserId)
                "
                class="tel"
                ><img src="@/assets/img/tel.png" alt=""
              /></a>
            </div>
            <div class="num m_flex_box flex_vc">
              <img src="@/assets/img/check.png" alt="" /><span>核验编码</span
              >{{ item.uniqueCode }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pad_bottom"></div>
    <div class="footer_d m_flex_box flex_vc flex_jz">
      <div class="collect flex_v flex_hc flex_vc" @click="collectOption">
        <img :src="isCollect ? collected : collectNo" alt="" />
        <span>{{ isCollect ? "已收藏" : "收藏" }}</span>
      </div>
      <div class="btn_con m_flex_box">
        <a
          @click="talkUrl(adviserList.chatUrl)"
          class="green flex_v flex_hc flex_vc"
          v-if="JSON.stringify(adviserList) != '{}'"
        >
          <h5>在线咨询</h5>
          <!-- <p>专业客服为你服务</p> -->
        </a>
        <a
          @click="callTo(adviserList.phone, 2, adviserList.id)"
          class="light flex_v flex_hc flex_vc"
          v-if="JSON.stringify(adviserList) != '{}'"
        >
          <h5>电话咨询</h5>
        </a>
        <a
          @click="callTo('4006212666,1', 3, obj.itemId)"
          class="light flex_v flex_hc flex_vc"
          v-else
        >
          <h5>电话咨询</h5>
          <!-- <p>专业客服为你服务</p> -->
        </a>
        <div class="dark flex_v flex_hc flex_vc" @click="toBuy">
          <h5>我要买房</h5>
          <!-- <p>一键搜全城</p> -->
        </div>
      </div>
    </div>
    <img class="to_top" @click="toTop" src="@/assets/img/toTop.png" alt="" />
    <div class="load_con m_flex_box flex_vc flex_hc" v-if="isLoading">
      <div class="inner flex_v flex_vc flex_hc ">
        <van-loading />
        <p>加载中...</p>
      </div>
    </div>
    <van-dialog
      v-model="showPopup"
      title="我要买房"
      show-cancel-button
      @confirm="confirmDialog"
      @cancel="cancelDialog"
    >
      <van-form :scroll-to-error="true" class="buyHouse">
        <van-field
          v-model="formDate.wname"
          name="name"
          type="text"
          label="姓名:"
          placeholder="请输入姓名"
          :disabled="btnDis"
        />
        <van-field
          v-model="formDate.wphone"
          name="phone"
          type="text"
          label="手机:"
          placeholder="请输入手机号"
          maxlength="11"
          :disabled="btnDis"
        />
        <div class="buyHouse_word">
          是否授权新房严选顾问为您提供专属服务?我们会有专属客服人员与您联系，为您提供优质、专属、专业的房产服务。
        </div>
      </van-form>
    </van-dialog>
  </div>
</template>

<script>
const map1 = require("@/assets/img/map/1.png");
const map2 = require("@/assets/img/map/2.png");
const map3 = require("@/assets/img/map/3.png");
const map4 = require("@/assets/img/map/4.png");
const map5 = require("@/assets/img/map/5.png");
import qs from "qs";
import { ImagePreview } from "vant";
import topHeader from "@/components/header";
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import { mapGetters } from "vuex";
export default {
  name: "ProjectDetail",
  data() {
    return {
      btnDis: false,
      formDate: {
        wname: "",
        wphone: "",
      },
      showPopup: true,
      adviserList: {},
      isLoading: true,
      pic: require("@/assets/img/tx.jpg"),
      bgColor: "transparent",
      textColor: "#fff",
      tabIndex: 0,
      collected: require("@/assets/img/collect_.png"),
      collectNo: require("@/assets/img/collect.png"),
      isCollect: 0,
      topSwiperIndex: 0,
      announceTab: 0,
      scale: 1,
      swiperOptionh: {
        on: {
          slideChangeTransitionStart: (data) => {
            this.topSwiperIndex = data.activeIndex;
          },
        },
        pagination: {},
      },
      swiperOptionv: {},
      zoom: 10,
      markerList: [{ lng: 117.290313, lat: 34.209974 }],
      active: false,
      icon: require("@/assets/img/zulinxiangqing_ditu_icon.png"),
      icon1: map1,
      center: {},
      center1: {},
      options: {},
      local: null,
      keyword: "公交",
      show: false,
      infoPosition: {},
      infoWindow: "",
      zScore: 0,
      nearby: {
        center: {
          lat: 34.209974,
          lng: 117.290313,
        },
        radius: 2000,
      },
      mapList: [],
      offset: { height: -16, width: 0 },
      showPad: false,
      obj: {},
      itemId: "",
      videoList: [], //视频
      swiperImg: [], //轮播图片
      personList: [], //经纪人
      hxList: [], //户型
      oneHouseList: [], //一房一价
      newsList: [], //新闻
      nktList: [], //鸟瞰图
      announceArr: [], //预售现售
      announceArr1: [], //预售现售
      showAnnounce: false,
      showAnnounce1: false,
      checkObj: {},
      checkObj1: {},
      argumentList: [],
      ad: "",
      scoreObj: {
        score2: 0,
        score3: 0,
        score4: 0,
        zScore: 0,
        score1: 0,
      },
      recommendList: [],
      oldList: [],
      nktCurrent: 0,
      hxIndex: 0,
      offsetTop: 0,
    };
  },
  components: {
    topHeader,
    Swiper,
    SwiperSlide,
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  watch: {
    userInfo: {
      handler(n) {
        console.log("n.realName", n.realName);
        if (n.realName) {
          this.getCollect();
        }
      },
      deep: true,
    },
  },
  provide() {
    return {
      reload: this.reload,
    };
  },
  filters: {
    timeFormat(dates, fmt) {
      if (dates) {
        var date = new Date(dates);
        if (/(y+)/.test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            (date.getFullYear() + "").substr(4 - RegExp.$1.length)
          );
        }
        var o = {
          "M+": date.getMonth() + 1,
          "d+": date.getDate(),
          "h+": date.getHours(),
          "m+": date.getMinutes(),
          "s+": date.getSeconds(),
        };
        for (var k in o) {
          if (new RegExp("(" + k + ")").test(fmt)) {
            var str = o[k] + "";
            fmt = fmt.replace(
              RegExp.$1,
              RegExp.$1.length === 1 ? str : ("00" + str).substr(str.length)
            );
          }
        }
        return fmt;
      } else {
        return "-";
      }
    },
    formatwan(param) {
      if (param >= 10000) {
        return (param / 10000).toFixed(2) + "w";
      } else {
        return param;
      }
    },
  },
  created() {
    if (
      window.sessionStorage.getItem("popup") == 1 ||
      window.sessionStorage.getItem("popup") == "1"
    ) {
      this.showPopup = false;
    }
    this.$http.post("cms/onlineUser/reg/isLogin.do").then((res) => {
      if (res.success) {
        this.formDate.wname = res.obj.realName;
        this.formDate.wphone = res.obj.phone;
        this.btnDis = true;
      }
    });
    this.itemId = this.$route.query.itemId;
  },
  inject: ["reload"],
  mounted() {
    this.getUserByItemId();
    window.addEventListener("scroll", this.handleScroll);
    this.offsetTop = document.querySelector(".detail_nav_bar").offsetTop;
    this.getDetails();
    this.getAllPer();
    this.getOnehouse();
    this.getNews();
    this.getNkt();
    this.getAnnounce();
    this.getAnnounce1();
    this.getArgument();
    this.getRecommend();
    this.getOld();
    this.getAd();
    console.log("this.userInfo.realName", this.userInfo.realName);
    if (this.userInfo.realName) {
      this.getCollect();
    }
  },
  methods: {
    confirmDialog() {
      this.$new
        .post("sale/addWymf.do", qs.stringify(this.formDate))
        .then((res) => {
          if (res.success) {
            this.$toast(res.msg);
            window.sessionStorage.setItem("popup", 1);
          } else {
            this.$toast(res.msg);
            window.sessionStorage.setItem("popup", 1);
          }
        });
    },
    cancelDialog() {
      window.sessionStorage.setItem("popup", 1);
    },
    talkUrl(comment) {
      if (comment) {
        window.location.href = comment;
      } else {
        this.$dialog.alert({
          title: "提示",
          message: "暂时可咨询客服",
        });
        return;
      }
    },
    getUserByItemId() {
      this.$request
        .get("erpService/yw/api/customer/getUserByItemId?itemId=" + this.itemId)
        .then((res) => {
          if (res.success) {
            this.adviserList = res.result;
          } else {
            // this.$toast(res.message);
          }
        });
    },
    callTo_(phone, lx, infoId) {
      if (!phone) {
        this.$dialog.alert({
          title: "提示",
          message: "暂无可拨打电话",
        });
        return;
      }
      this.$http.post("cms/onlineUser/reg/isLogin.do").then((res) => {
        if (res.success) {
          this.$new
            .post(
              "telTj/addTeltj.do",
              qs.stringify({
                phone,
                lx,
                infoId,
              })
            )
            .then((res) => {
              window.location.href = `tel:${phone}`;
            });
        } else {
          this.$toast(res.msg);
        }
      });
    },

    callTo(phone, lx, infoId) {
      if (!phone) {
        this.$dialog.alert({
          title: "提示",
          message: "暂无可拨打电话",
        });
        return;
      }
      this.$new
        .post(
          "telTj/addTeltj.do",
          qs.stringify({
            phone,
            lx,
            infoId,
          })
        )
        .then((res) => {
          window.location.href = `tel:${phone}`;
        });
    },
    toBuy() {
      this.$router.push({
        path: "/buyHouse",
      });
    },
    toTalk(id) {
      this.$router.push({
        path: "/chat",
        query: {
          id,
        },
      });
    },

    //toCall(item.id,item.zxdh,1)
    //window.location.href = domains + '/#' + 'houseDetail?houseListedId='+item.listedId+'&mainId='+item.houseListed.mainId

    toDetail1(saleItemId) {
      this.$router.push({
        path: "/saleProgress",
        query: { saleItemId },
      });
    },
    /*    toDetail2(id) {
          this.$router.push({
            path: '/newsDetail',
            query: {id}
          })
        },*/
    toDetail3(saleItemId) {
      this.$router.push({
        path: "/announceDetail",
        query: { saleItemId },
      });
    },

    toOneHouseOnePrice(itemId) {
      this.$router.push({
        path: "/oneHouseOnePrice",
        query: { itemId },
      });
    },
    toDetail(itemId, houseId) {
      this.$router.push({
        path: "/oneHouseOnePriceDetail",
        query: { itemId, houseId },
      });
    },
    collectOption() {
      this.$http
        .post(
          "cms/houseCollect/reg/addNewHouseCollect.do",
          qs.stringify({
            itemId: this.itemId,
          })
        )
        .then((res) => {
          this.$toast(res.msg);
          if (res.success) {
            if (res.msg === "已为您成功添加收藏") {
              this.isCollect = 1;
            } else {
              this.isCollect = 0;
            }
          }
        });
    },
    getCollect() {
      this.$http
        .post(
          "cms/houseCollect/reg/getNewHouseCollect.do",
          qs.stringify({
            itemId: this.itemId,
          })
        )
        .then((res) => {
          if (res.success) {
            this.isCollect = res.obj;
          }
        });
    },
    toProject(itemId, old) {
      if (old == 1) {
        this.$router.push({
          path: "/projectDetailIndex",
          query: {
            itemId: itemId,
          },
        });
      } else {
        this.$router.push({
          path: "/projectDetail",
          query: {
            itemId: itemId,
          },
        });
      }
    },
    getDetail(itemId, old) {
      if (old == 1) {
        this.$router.push({
          path: "/projectDetailIndex",
          query: {
            itemId: itemId,
          },
        });
      } else {
        this.$router.push({
          path: "/projectDetail",
          query: {
            itemId: itemId,
          },
        });
        this.reload();
      }
    },

    getDetails() {
      this.$new
        .post(
          "itemInfo/getItemById.do",
          qs.stringify({
            id: this.itemId || "dd6b800b1d2d4144840ec1e2144b5bcc",
          })
        )
        .then((res) => {
          var Img = this.logoImg;
          var url = window.location.href;
          var hosts = url.split("/#/")[0]; //获取域名加打包文件夹名称
          var shareImg = hosts.concat("/" + Img);
          this.$share(res.obj.tgmc, res.obj.ms, shareImg);
          this.isLoading = false;
          this.obj = res.obj;
          this.zScore = res.obj.zScore;
          this.center = {
            lng: res.obj.zb.split(",")[0],
            lat: res.obj.zb.split(",")[1],
          };
          this.center1 = {
            lng: res.obj.zb.split(",")[0],
            lat: res.obj.zb.split(",")[1],
          };
          this.zoom = 15;
          this.$set(this.nearby.center, "lng", res.obj.zb.split(",")[0]);
          this.$set(this.nearby.center, "lat", res.obj.zb.split(",")[1]);
          this.videoList = res.obj.video;
          const imgArr = [];
          for (let i = 0; i < res.obj.img.length; i++) {
            for (let j = 0; j < res.obj.img[i].imgList.length; j++) {
              imgArr.push(res.obj.img[i].imgList[j]);
            }
          }
          this.swiperImg = imgArr;
          res.obj.img.forEach((item, index) => {
            if (item.name === "户型效果图") {
              this.hxList = item.imgList || [];
              this.hxIndex = index;
            }
          });
        });
    },
    getBroker() {
      return new Promise((resolve) => {
        this.$http
          .post(
            "cms/broker/permit/getItemBrokerList.do",
            qs.stringify({
              itemId: this.itemId || "dd6b800b1d2d4144840ec1e2144b5bcc",
            })
          )
          .then((res) => {
            resolve(res.obj);
          });
      });
    },
    getZy() {
      return new Promise((resolve) => {
        this.$new
          .post(
            "sale/getZygwList.do",
            qs.stringify({
              itemId: this.itemId || "dd6b800b1d2d4144840ec1e2144b5bcc",
            })
          )
          .then((res) => {
            resolve(res.obj);
          });
      });
    },
    getAllPer() {
      Promise.all([this.getBroker(), this.getZy()]).then((res) => {
        let newArr = [];
        if (res[0]) {
          newArr = newArr.concat(res[0]);
        }
        if (res[1]) {
          newArr = newArr.concat(res[1]);
        }
        this.personList = newArr;
      });
    },
    getOnehouse() {
      var that = this;
      that.$new
            .post(
              "houseApi/getHouseList.do",
              qs.stringify({
                itemId: that.itemId,
                type: 2,
                order: 1,
                pageSize: 2,
                currPageNo: 1,
                xzqh: that.main.getHostArea(),
              })
            )
            .then((res) => {
              that.oneHouseList = res.obj || [];
            });
    },
    getNews() {
      this.$new
        .post(
          "itemInfo/getItemNewsById.do",
          qs.stringify({
            pageSize: 2,
            currPageNo: 1,
            itemId: this.itemId || "7c2bf0da11494dd798cc447dc3cb2cc8",
          })
        )
        .then((res) => {
          this.newsList = res.obj || [];
        });
    },
    getNkt() {
      this.$new
        .post(
          "itemInfo/getAerialViewByItem.do",
          qs.stringify({
            itemId: this.itemId || "5f66988446724e67a3a78fbfee65d2ce",
          })
        )
        .then((res) => {
          this.nktList = res.obj || [];
        });
    },
    getAnnounce() {
      this.$new
        .post(
          "salePermit/getYsxxByItemId.do",
          qs.stringify({
            itemId: this.itemId || "dd6b800b1d2d4144840ec1e2144b5bcc",
          })
        )
        .then((res) => {
          this.announceArr = res.obj || [];
          if (res.obj) {
            this.checkObj = res.obj[0];
          }
        });
    },
    getAnnounce1() {
      this.$new
        .post(
          "estRecord/getXsxxByItemId.do",
          qs.stringify({
            itemId: this.itemId,
          })
        )
        .then((res) => {
          this.announceArr1 = res.obj || [];
          if (res.obj) {
            this.checkObj1 = res.obj[0];
          }
        });
    },
    getArgument() {
      this.$new
        .post(
          "itemInfo/getCommentByPage.do",
          qs.stringify({
            pageSize: 2,
            currPageNo: 1,
            xzqh: this.main.getHostArea(),
            contentType: 1,
            itemId: this.itemId || "dd6b800b1d2d4144840ec1e2144b5bcc",
          })
        )
        .then((res) => {
          this.argumentList = res.obj || [];
          if (res.attributes) {
            this.scoreObj = res.attributes.avgScore;
          }
        });
    },
    getRecommend() {
      this.$new
        .post(
          "promoteHouse/getTypePage.do",
          qs.stringify({
            pageSize: 4,
            currPageNo: 1,
            xzqh: this.main.getHostArea(),
            type: 4,
          })
        )
        .then((res) => {
          this.recommendList = res.obj || [];
        });
    },
    getOld() {
      this.$http({
        url: "cms/houseListed/permit/getHouseList.do",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          area: this.main.getHostArea(),
          offset: 0,
          pageSize: 4,
          sort: 0,
          itemId: this.itemId,
        },
      }).then((res) => {
        this.oldList = res.obj ? res.obj.rows : [];
      });
    },
    setNkt(index) {
      this.nktCurrent = index;
    },
    confirm(data) {
      this.checkObj = data;
      this.showAnnounce = false;
    },
    confirm1(data) {
      this.checkObj1 = data;
      this.showAnnounce1 = false;
    },
    toNews(id) {
      this.$router.push({
        path: "/newsDetail",
        query: {
          id,
        },
      });
    },
    toImg() {
      this.$router.push({
        path: "/photo",
        query: {
          itemId: this.itemId,
          index: this.videoList.length ? this.hxIndex + 1 : this.hxIndex,
        },
      });
    },
    toOld(obj) {
      this.$router.push({
        path: "/houseDetail",
        query: {
          houseListedId: obj.id,
          mainId: obj.mainId,
        },
      });
    },
    toOneHouse() {
      this.$router.push({
        path: "/oneHouseOnePrice",
        query: {
          itemId: this.itemId,
        },
      });
    },
    showMsg(tit, text) {
      var dyLx1 = 0;
      var dyLx2 = 0;
      var dyLx3 = 0;
      if (tit === "预售早知道") {
        dyLx1 = 1;
      }
      if (tit === "楼盘动态") {
        dyLx2 = 1;
      }
      if (tit === "我要买房") {
        this.$router.push({
          path: "/buyHouse",
        });
        return;
      }
      //项目订阅   接口 64
      this.$dialog
        .confirm({
          title: text,
          message:
            '选择"提交",我们会为您提供及时的消息推送服务，并将收集您的姓名及手机号码用作后续的专属服务，届时将有专属客服人员与您电话联系，提供优质而专业的房产资讯服务。',
        })
        .then((res) => {
          this.$http
            .post(
              "cms/xzhouse/reg/addXxdy.do",
              qs.stringify({
                itemId: this.itemId,
                dyLx1: dyLx1,
                dyLx2: dyLx2,
                dyLx3: dyLx3,
              })
            )
            .then((res) => {
              if (res.success) {
                this.$toast(res.msg);
              } else {
                this.$toast(res.msg);
              }
            });
        })
        .catch(() => {});
    },
    handler({ BMap, map }) {
      this.map = map;
    },
    changeMap(key) {
      this.keyword = key;
      this.infoWindowClose();
      switch (key) {
        case "公交":
          this.icon1 = map1;
          break;
        case "医疗":
          this.icon1 = map2;
          break;
        case "银行":
          this.icon1 = map3;
          break;
        case "商业":
          this.icon1 = map4;
          break;
        case "学校":
          this.icon1 = map5;
          break;
        default:
          this.icon1 = map1;
      }
    },
    search(data) {
      this.$set(this, "mapList", data.Ir);
    },
    setCenter(data) {
      this.$set(this.center1, "lng", data.marker.point.lng);
      this.$set(this.center1, "lat", data.marker.point.lat);
      this.getPane(data);
      this.zoom = 15;
    },
    infoWindowOpen(e) {
      this.show = true;
    },
    infoWindowClose(e) {
      this.show = false;
    },
    // 获取广告
    getAd() {
      this.$new
        .post(
          "ad/getAdList.do",
          qs.stringify({
            xzqh: this.main.getHostArea(),
            type: 5,
          })
        )
        .then((res) => {
          if (res.obj) {
            this.ad = res.obj;
          }
          // this.offsetTop = document.querySelector('.tab_con').offsetTop
        });
    },
    getPane(data) {
      this.$set(this.infoPosition, "lng", data.marker.point.lng);
      this.$set(this.infoPosition, "lat", data.marker.point.lat);
      this.infoWindowOpen();
      this.infoWindow = `<div><h5>${data.title}</h5><p>${data.address}</p></div>`;
    },
    toTop() {
      this.$refs.topBanner.scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start", // 上边框与视窗顶部平齐。默认值
      });
    },
    toSlide(index) {
      if (this.videoList.length) {
        this.$refs.mySwiper.$swiper.slideTo(index, 200);
      } else {
        this.$refs.mySwiper.$swiper.slideTo(index - 1, 200);
      }
    },
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (
        scrollTop >
        this.offsetTop - (document.documentElement.clientWidth / 7.5) * 0.9
      ) {
        this.showPad = true;
      } else {
        this.showPad = false;
      }
      if (scrollTop > (document.documentElement.clientWidth / 7.5) * 5.6) {
        this.textColor = "#000";
        this.bgColor = "#fff";
      } else {
        this.textColor = "#fff";
        this.bgColor = "transparent";
      }
    },
    showImg(list, index) {
      const newArr = [];
      list.forEach((item) => {
        newArr.push("data:image/jpg;base64," + item);
      });
      ImagePreview({
        images: newArr,
        startPosition: index,
      });
    },
    showModel(parent, index) {
      this.$router.push({
        path: "/photo",
        query: {
          itemId: this.itemId,
        },
      });
    },
    toUrl(path, type) {
      console.log(this.itemId);
      this.$router.push({
        path,
        query: {
          itemId: this.itemId,
          type: type || "",
        },
      });
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
<style lang="less" scoped>
.overLy {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.4);
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
}
.buyHouse {
  padding: 5% 0;

  .buyHouse_word {
    padding: 5%;
    color: #ccc;
  }
}

.load_con {
  position: fixed;
  z-index: 9999;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  color: #fff;
  font-size: 14px;

  .inner {
    background-color: rgba(0, 0, 0, 1);
    padding: 16px;
    width: 88px;
    max-width: 70%;
    min-height: 88px;
    border-radius: 8px;
  }

  p {
    margin-top: 8px;
  }
}

video {
  height: 5.64rem;
  width: 100%;
  background-color: #000;
}

.top_banner {
  position: relative;
  height: 5.64rem;

  .total {
    background-color: rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 0.24rem;
    width: 1.2rem;
    line-height: 0.5rem;
    position: absolute;
    bottom: 0.24rem;
    right: 0.4rem;
    z-index: 9;
    text-align: center;
    border-radius: 0.25rem;
  }

  img {
    height: 5.64rem;
    width: 100%;
  }

  .slide_video_con {
    position: relative;

    .cover {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 5.64rem;
      background-color: rgba(0, 0, 0, 0.3);

      i {
        color: #fff;
        font-size: 1.4rem;
      }
    }
  }
}

.pagination {
  position: absolute;
  z-index: 9;
  bottom: 0.3rem;
  left: 0;
  right: 0;

  span {
    width: 0.76rem;
    line-height: 0.36rem;
    text-align: center;
    font-size: 0.22rem;
    margin: 0 0.1rem;
    background-color: #e6e6e6;
    color: #101010;
    border-radius: 0.18rem;

    &.active {
      background-color: #3072f5;
      color: #fff;
    }
  }
}

.top_info {
  width: 7.04rem;
  margin: 0.34rem auto;

  .top {
    margin-bottom: 0.24rem;
  }

  h3 {
    font-size: 0.38rem;
    font-weight: 800;
    width: 60%;
  }

  .price {
    font-size: 0.24rem;
    white-space: nowrap;

    span {
      color: #ff4532;
      font-size: 0.36rem;
    }
  }

  .score {
    img {
      width: 0.22rem;
      height: 0.22rem;
      margin-right: 0.06rem;
    }

    span {
      margin-left: 0.08rem;
    }
  }

  .fwl {
    font-size: 0.24rem;
    color: #909090;

    span {
      color: #101010;
      margin-left: 0.06rem;
    }
  }

  .icon {
    font-size: 0.22rem;
    margin-top: 0.3rem;

    span,
    i {
      padding: 0 0.1rem;
      line-height: 0.42rem;
      border-radius: 0.02rem;
      display: block;
    }

    span {
      background-color: #3072f5;
      color: #fff;
    }

    i {
      background-color: #ededed;
      margin-left: 0.08rem;
      color: #666;
    }
  }

  .middle_blue {
    margin-top: 0.44rem;
    height: 0.82rem;
    padding: 0 0.22rem;
    background-color: #eef4ff;

    img {
      margin-right: 0.1rem;
    }

    .left {
      img {
        width: 0.26rem;

        span {
          font-size: 0.26rem;

          i {
            font-weight: 800;
            font-size: 0.3rem;
          }
        }
      }
    }

    .right {
      img {
        width: 0.32rem;
        height: 0.3rem;
      }

      span {
        color: #3072f5;
        font-weight: 800;
      }
    }
  }
}

.text_con {
  width: 7.04rem;
  margin: 0 auto;
  font-size: 0.26rem;
  color: #919191;

  span {
    color: #101010;
    max-width: 5.42rem;
    margin-left: 0.2rem;
  }

  .row {
    margin-bottom: 0.2rem;
  }

  .detail_btn {
    display: block;
    background-color: #f3f3f3;
    color: #757575;
    font-size: 0.24rem;
    text-align: center;
    line-height: 0.68rem;
    margin-bottom: 0.32rem;
  }
}

.middle_btn {
  width: 7.04rem;
  padding-bottom: 0.32rem;
  margin: 0 auto;

  div {
    width: 2.26rem;
    height: 0.66rem;
    background-color: #f2f6ff;
    color: #2f72f5;
    font-size: 0.24rem;

    span {
      margin-left: 0.08rem;
    }

    img {
      width: 0.24rem;
    }
  }
}

.detail_nav_bar {
  &.fixed {
    background-color: #fff;
    position: fixed;
    top: 0.9rem;
    left: 0;
    right: 0;
    z-index: 2;
    border-top: 1px solid #e9e9e9;
  }

  white-space: nowrap;
  overflow: scroll;

  span {
    font-weight: 800;
    display: inline-block;
    padding: 0 0.3rem;
    font-size: 0.3rem;
    line-height: 0.9rem;
    position: relative;

    &.active {
      color: #3072f5;
      font-size: 0.32rem;

      &:after {
        content: "";
        display: block;
        position: absolute;
        width: 0.48rem;
        height: 0.04rem;
        background-color: #3072f5;
        border-radius: 0.02rem;
        left: 50%;
        margin-left: -0.24rem;
        bottom: 0.1rem;
      }
    }
  }
}

.main_inner {
  width: 7.04rem;
  margin: 0 auto;
  display: block;
  padding: 0.4rem 0;

  .tit_con {
    margin-bottom: 0.28rem;
  }

  .inner_tit {
    font-size: 0.34rem;
    font-weight: 800;
  }

  .arrow {
    color: #aaabae;
    font-size: 0.24rem;

    i {
      margin-left: 0.12rem;
    }
  }

  .text_con {
    line-height: 0.42rem;
  }
}

.people_con {
  white-space: nowrap;
  overflow: auto;
  display: flex;
  padding: 0.48rem 0.08rem 0.08rem;

  .inner {
    display: flex;
    // width: 3rem;
    // height: 2rem;
    box-sizing: border-box;
    box-shadow: 0rem 0rem 0.08rem rgba(0, 0, 0, 0.15);
    border-radius: 0.04rem;
    padding: 0.2rem;
    box-sizing: border-box;
    margin-right: 0.16rem;
    text-align: center;

    &:last-child {
      margin-right: 0;
    }

    .atavr {
      // position: relative;
      // top: -0.48rem;
      width: 1.3rem;
      height: 1.3rem;
      border-radius: 50%;
      display: block;
      margin: 0 auto;
    }

    .name {
      font-size: 0.26rem;
      // margin-top: -0.34rem;
      font-weight: 800;
    }

    .intro {
      font-size: 0.26rem;
      margin: 0.08rem 0 0.14rem;
    }

    .btn_con {
      width: 100%;
      padding-top: 0.12rem;
      // border-top: 1px solid #f4f4f4;
      text-align: center;
      font-size: 0.22rem;
      color: #606060;

      img {
        width: 0.4rem;
        height: 0.4rem;
      }
    }
  }

  .inner_new {
    flex-direction: column;
    width: 100%;
    // padding: 0.3rem 0.2rem;
    margin-right: 0;

    .atavr {
      width: 1.8rem;
      height: 1.8rem;
    }

    .info_c {
      margin-top: 0.1rem;
      border-top: 1px solid #efefef;
    }

    .info_a {
      display: flex;
      padding: 0 0.5rem;

      //  &>div:first-child{
      //   position: relative;
      //   top:-0.5rem
      //  }
      & > div:last-child {
        flex: 1;
        flex-direction: column;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .name {
      font-size: 0.5rem;
    }

    .btn_con {
      img {
        width: 0.5rem;
        height: 0.5rem;
      }

      & > a {
        margin-left: 0.3rem;
      }
    }
  }
}

.hx_con {
  overflow: auto;
  white-space: nowrap;

  .inner {
    display: inline-block;
    width: 3.36rem;
    font-size: 0.28rem;
    margin-right: 0.2rem;

    &:last-child {
      margin-right: 0;
    }

    .img_con {
      width: 3.36rem;
      height: 2.52rem;
      border: 1px solid #f0f0f0;
      border-radius: 0.08rem;
      padding: 0.08rem;
      box-sizing: border-box;
      margin-bottom: 0.14rem;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}

.price_list {
  .inner {
    padding: 0.3rem 0;
    border-bottom: 1px solid #f4f4f4;

    &:last-child {
      padding: 0.3rem 0 0;
      border-bottom: 0;
    }

    .left {
      width: 1.94rem;

      img {
        width: 100%;
        height: 1.86rem;
        border: 1px solid #dcdcdc;
        border-bottom: 0;
        display: block;
        box-sizing: border-box;
      }

      p {
        color: #fff;
        background-color: #ff472e;
        font-size: 0.22rem;
        padding: 0.04rem;
        text-align: center;
      }
    }

    .right {
      width: 4.84rem;

      img {
        width: 100%;
      }

      .top {
        position: relative;
        top: -0.04rem;

        h5 {
          font-size: 0.3rem;
          margin-bottom: 0.12rem;
          max-width: 80%;
        }

        span {
          font-size: 0.22rem;
          color: #3072f5;
          border: 1px solid currentColor;
          padding: 0.02rem 0.06rem;
          border-radius: 0.04rem;
        }
      }

      .icon_con {
        margin-top: 0.08rem;

        span {
          padding: 0.04rem 0.06rem;
          color: #6c6d71;
          font-size: 0.22rem;
          background-color: #eef1f6;
          border-radius: 0.04rem;
          margin-right: 0.12rem;

          &:last-child {
            margin-right: 0;
          }
        }
      }
    }
  }
}

.news_list {
  .inner {
    padding: 0.3rem 0;
    border-bottom: 1px solid #f4f4f4;

    &:last-child {
      padding: 0.3rem 0 0;
      border: 0;
    }

    .right {
      width: 4.46rem;

      .tit {
        color: #202020;
        font-size: 0.28rem;
        margin-bottom: 0.2rem;
        line-height: 0.44rem;
      }

      .time {
        i {
          background-color: #f4f4f4;
          font-size: 0.22rem;
          padding: 0.02rem 0.06rem;
          color: #666;
          border-radius: 0.02rem;
        }

        span {
          color: #999;
          margin-left: 0.1rem;
        }
      }
    }

    .left {
      img {
        width: 2.08rem;
        height: 1.58rem;
      }
    }
  }
}

.ad_con {
  padding-top: 0.3rem;

  img {
    height: 1.68rem;
    width: 100%;
    display: block;
  }
}

.nkt_con {
  width: 7.04rem;
  height: 5.26rem;
  overflow: auto;

  #box {
    width: 100%;
    height: 100%;
    position: relative;
    transform-origin: 0 0;

    img {
      width: 100%;
      height: 100%;
    }

    .icon_con {
      background-color: rgba(255, 255, 2, 0.5);

      span {
        background-color: #3072f5;
        color: #fff;
        display: block;
        position: absolute;
        padding: 0.04rem 0.08rem;
        font-size: 0.22rem;
        border-radius: 0.04rem;
        top: 0.28rem;
        z-index: 2;

        &:after {
          content: "";
          display: block;
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 0.08rem;
          border-color: #3072f5 transparent transparent transparent;
          position: absolute;
          left: 50%;
          margin-left: -0.08rem;
        }
      }
    }
  }
}

.map_tab {
  font-size: 0.32rem;
  font-weight: 800;
  margin-bottom: 0.32rem;

  span {
    position: relative;
    height: 0.64rem;
    margin: 0 0.4rem;

    &.active {
      font-size: 0.34rem;
      color: #3072f5;

      &:after {
        content: "";
        display: block;
        width: 0.48rem;
        height: 0.04rem;
        background-color: #3072f5;
        border-radius: 0.02rem;
        position: absolute;
        left: 50%;
        margin-left: -0.24rem;
        bottom: 0;
      }
    }
  }
}

.announce_blue {
  background-color: #f1f6ff;
  color: #3072f5;
  font-size: 0.26rem;
  height: 0.78rem;

  .play {
    transform: rotate(90deg);
    margin-left: 0.1rem;
  }
}

.announce_img {
  width: 100%;
  height: 5.3rem;
  display: block;
  margin: 0.3rem 0 0.1rem;

  img {
    width: 100%;
    height: 100%;
  }
}

.announce_list {
  .row {
    height: 0.76rem;
    border-bottom: 1px solid #f5f5f5;
    font-size: 0.24rem;
    color: #8f8f8f;

    span {
      font-size: 0.26rem;
      font-weight: 800;
      width: 2.36rem;
      color: #1f1f1f;
    }
  }
}

.announce_main {
  .btn_con {
    margin-top: 0.3rem;

    span {
      width: 2.26rem;
      line-height: 0.66rem;
      font-size: 0.24rem;
      font-weight: 800;
      color: #3072f5;
      text-align: center;
      background-color: #f2f7ff;
    }
  }
}

.bm-view {
  width: 100%;
  height: 3.88rem;
}

.map_tab_con {
  white-space: nowrap;
  margin-bottom: 0.3rem;
  overflow: auto;

  span {
    display: inline-block;
    font-size: 0.26rem;
    font-weight: 800;
    background-color: #f0f0f0;
    line-height: 0.56rem;
    width: 1.2rem;
    border-radius: 0.28rem;
    text-align: center;
    margin-right: 0.1rem;

    &.active {
      background-color: #e8f0ff;
      color: #2f72f5;
    }
  }
}

.map_list {
  max-height: 3rem;
  overflow: auto;

  .row {
    padding: 0.12rem 0rem;
    border-bottom: 1px solid #f4f4f4;

    span {
      font-size: 0.26rem;
      font-weight: 600;
      width: 0.46rem;
      text-align: center;
    }

    .right {
      width: 92%;

      h5 {
        font-size: 0.26rem;
        font-weight: 800;
      }

      p {
        font-size: 0.24rem;
      }
    }
  }
}

.no_map {
  font-size: 0.24rem;
  font-weight: 600;
  color: #999;
  height: 2rem;
}

/deep/ .BMap_Marker {
  img {
    width: 100%;
    object-fit: contain;
  }
}

/deep/ .BMap_pop {
  > img:nth-of-type(1) {
    display: none;
  }

  > div:not(:nth-child(9)) {
    display: none;
  }

  div:nth-child(9) {
    background-color: #2a7df9;
    box-sizing: border-box;
    height: auto !important;
    width: 3rem !important;
    left: 0.6rem !important;
    border-radius: 0.1rem;
    color: #fff;
    font-size: 0.22rem;
    padding: 0.2rem;
    box-sizing: border-box;
    overflow: visible !important;

    &:after {
      content: "";
      display: block;
      border-style: solid;
      border-width: 0.08rem;
      border-color: #2a7df9 transparent transparent transparent;
      position: absolute;
      top: 100%;
      margin-left: -0.16rem;
      left: 50%;
    }

    h5 {
      font-weight: 800;
      font-size: 0.24rem;
      margin-bottom: 0.1rem;
    }
  }
}

.argument_con {
  .argument_top {
    h5 {
      margin-right: 0.12rem;
      font-size: 0.3rem;
      color: #ff2a2a;

      span {
        font-size: 0.32rem;
        font-weight: 800;
      }
    }

    .score_text {
      font-size: 0.24rem;
      margin-top: 0.1rem;
      color: #303030;

      span {
        margin-right: 0.24rem;
      }
    }

    .argument_btn {
      display: block;
      margin-top: 0.4rem;
      background-color: #fff4f2;
      color: #ff5c5c;
      line-height: 0.78rem;
      text-align: center;
    }
  }

  .icon_con {
    img {
      width: 0.26rem;
      margin-right: 0.06rem;
    }
  }
}

.argument_list {
  .row {
    padding: 0.4rem 0;
    border-bottom: 1px solid #f5f5f5;

    &:last-child {
      border-bottom: 0;
    }

    .row_top {
      .avatr {
        width: 0.78rem;
        border-radius: 50%;
        margin-right: 0.16rem;
      }

      .top_l_r {
        p {
          font-size: 0.26rem;
          margin-bottom: 0.12rem;
        }
      }

      .time {
        font-size: 0.24rem;
        color: #838383;
      }
    }
  }

  .argumennt_b {
    margin-top: 0.3rem;

    h5 {
      font-size: 0.26rem;
      color: #252525;
      margin-bottom: 0.2rem;
      font-weight: 800;
    }

    .score_text {
      font-size: 0.22rem;
      color: #9a9a9a;

      span {
        margin-right: 0.16rem;
      }
    }

    .img_list {
      img {
        width: 1.6rem;
        height: 1.2rem;
        margin-right: 0.1rem;
      }
    }
  }

  .go_btn {
    display: block;
    background-color: #f1f6ff;
    color: #2f72f5;
    line-height: 0.78rem;
    text-align: center;
  }
}

.list_con {
  margin: 0.05rem auto 0;
  width: 7.04rem;

  .inner {
    .banner {
      width: 2.44rem;
      height: 1.84rem;
    }

    padding: 0.35rem 0;
    border-bottom: 1px solid #f4f4f4;
  }

  .new_r {
    img {
      width: 100%;
    }

    .tel {
      width: 0.36rem;
      height: 0.36rem;
    }

    width: 4.25rem;
    margin-left: 0.3rem;

    .col_gray {
      font-size: 0.24rem;
      color: #505050;
    }

    .tit {
      h4 {
        font-size: 0.36rem;
        color: #101010;
        font-weight: 800;
        width: 3rem;
      }

      i {
        padding: 0 0.04rem;
        line-height: 0.34rem;
        color: #2f72f5;
        font-size: 0.24rem;
        text-align: center;
        border: 1px solid currentColor;
        box-sizing: border-box;
        border-radius: 0.02rem;
      }

      span {
        width: 0.6rem;
        height: 0.34rem;
        text-align: center;
        line-height: 0.34rem;
        color: #fff;
        background-color: #24d064;
        font-size: 0.24rem;
        border-radius: 0.02rem;
      }
    }
  }
}

.new_list {
  .inner {
    .new_r {
      .col_gray {
        margin: 0.1rem 0;
      }

      .info {
        color: #505050;
        font-size: 0.24rem;

        p {
          margin-right: 0.2rem;
        }

        span {
          color: #ff6a18;
        }
      }

      .col_red {
        margin-top: 0.1rem;

        h4 {
          font-size: 0.36rem;
          font-weight: 800;
        }

        span {
          font-size: 0.22rem;
        }
      }

      .text {
        margin-top: 0.1rem;
        font-size: 0.22rem;
        color: #a0a0a0;

        i {
          font-size: 0.18rem;
        }
      }
    }
  }
}

.footer_d {
  background-color: #fff;
  left: 0;
  right: 0;
  position: fixed;
  height: 0.98rem;
  padding: 0 0.12rem;
  bottom: 0;
  border-top: 1px solid #f0f0f0;

  .collect {
    width: 1.4rem;

    img {
      width: 0.36rem;
    }

    span {
      font-size: 0.24rem;
      color: #636363;
      margin-top: 0.1rem;
    }
  }

  .btn_con {
    flex: 1;

    > div,
    > a {
      flex: 1;
      // width: 1.88rem;
      height: 0.84rem;
      color: #fff;
      border-radius: 0.06rem;

      h5 {
        font-size: 0.24rem;
        font-weight: 800;
      }

      p {
        font-size: 0.22rem;
      }

      &.light {
        background-color: #17c5fb;
        margin-right: 0.12rem;
      }

      &.green {
        background-color: #70db93;
        margin-right: 0.12rem;
      }

      &.dark {
        background-color: #2f72f5;
      }
    }
  }
}

.pad_bottom {
  padding-top: 0.6rem;
}

.mid_pad {
  padding-top: 0.92rem;
}

.to_top {
  width: 0.84rem;
  height: 0.84rem;
  position: fixed;
  z-index: 8;
  right: 0.15rem;
  bottom: 2rem;
}

.old_list {
  .inner {
    .inner_l {
      position: relative;

      i {
        width: 0.6rem;
        height: 0.34rem;
        text-align: center;
        line-height: 0.34rem;
        color: #fff;
        background-color: #24d064;
        font-size: 0.24rem;
        position: absolute;
        display: block;
        top: 0;
      }
    }

    .new_r {
      .tit {
        margin-bottom: 0.08rem;
      }

      .col_gray {
        margin: 0.04rem 0;
      }

      .price {
        h4 {
          font-size: 0.34rem;
          color: #ff4532;
          margin-bottom: 0;
          font-weight: 800;
        }

        p {
          font-size: 0.24rem;
          color: #aaaaaa;
          margin-left: 0.12rem;
        }
      }

      .num {
        margin-top: 0.04rem;
        color: #3072f5;

        img {
          width: 0.3rem;
          height: 0.3rem;
        }

        span {
          margin: 0 0.1rem;
          color: #383333;
        }
      }
    }
  }
}

.nkt_tab {
  white-space: nowrap;
  margin-bottom: 0.38rem;

  span {
    display: inline-block;
    background-color: #f0f0f0;
    color: #303030;
    line-height: 0.56rem;
    border-radius: 0.28rem;
    padding: 0 0.46rem;
    margin-right: 0.3rem;

    &:last-child {
      margin-right: 0;
    }

    &.active {
      background-color: #e8f0ff;
      color: #2f72f5;
      font-weight: 800;
    }
  }
}
</style>
